var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "article-slider" }, [
    _vm.slides && _vm.slides.length > 2
      ? _c(
          "div",
          {},
          [
            _c(
              "swiper",
              {
                ref: "articleSlider",
                attrs: { options: _vm.optionsPaginationTop },
              },
              _vm._l(_vm.slides, function (article, index) {
                return _c(
                  "swiper-slide",
                  { key: index },
                  [
                    _c("Article", {
                      attrs: {
                        title: article.title,
                        desc: article.summary,
                        date: article.datePublished,
                        size: null,
                        link: article.url,
                        author: article.author,
                        "has-access": _vm.hasAccess,
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("DirectionButton", {
              staticClass:
                "report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev",
              attrs: {
                "props-handle-click": _vm.prev,
                direction: "prev",
                icon: "arrow-left--white",
              },
            }),
            _vm._v(" "),
            _c("DirectionButton", {
              staticClass:
                "report-slider__pagination--next report-slider__pagination-top--next swiper-button-next",
              attrs: {
                "props-handle-click": _vm.next,
                direction: "next",
                icon: "arrow-right--white",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }